import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";

import setAuthToken from "./utils/api/token";

import NotFound from "./views/errors/404";
import SecureRoutes from "./routing/Routes";
import Tokenize from "./views/tokenize";
import EmailOptOut from "./views/public/email/optout";

import { get as getUser, logout } from "./actions/auth";

const App = ({ getUser, logout }) => {

  const [hydrated, setHydrated] = useState(false);
  async function __getUser() {
    try { await getUser(); } finally { setHydrated(true); }
  }

  async function __logout() {
    await logout();
  }
  useEffect(() => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
      __getUser();
    } else {
      setHydrated(true); // nothing to hydrate
    };

    // log user out from all tabs if they log out in one tab
    const onStorage = () => {
      if ((!localStorage.token) || (!localStorage.instance)) __logout();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  
  }, []);

  return (
    
    <BrowserRouter>
      {hydrated && (
        <Routes>
          <Route exact path="/authentic/tokenize" element={<Tokenize />} />
          <Route exact path="/public/email/optout" element={<EmailOptOut />} />
          <Route path="/dashboard/*" element={<SecureRoutes />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      )}
    </BrowserRouter>
  );
};

export default connect(null, { getUser, logout })(App);
